<template>
  <div :class="prefixCls">
    <div ref="editor"
         class="editor-wrapper"
         style="width: 125%;"></div>
    <p style="color:red;text-align: left;">
      不能超过3000个字符
    </p>
  </div>
</template>

<script>
import WEditor from "wangeditor";
export default {
  name: "WangEditor",
  props: {
    prefixCls: {
      type: String,
      default: "ant-editor-wang"
    },
    // eslint-disable-next-line
    value: {
      type: String
    },
    isedit: {
      type: Boolean
    }
  },
  data () {
    return {
      editor: null,
      editorContent: null
    };
  },
  mounted () {
    setTimeout(() => {
      this.initEditor();
    }, 500);
  },
  watch: {
    value: {
      handler (newVal, o) {
        if (this.editor !== null) {
          // 安评师应聘列表，初始化编辑器后查看不同简历，不同内容监听
          if (newVal !== null && newVal !== "") {
            this.editor.txt.html(newVal);
          }
        }
      },
      deep: true
    }
  },
  methods: {
    initEditor () {
      this.editor = new WEditor(this.$refs.editor);
      this.editor.customConfig.onchange = html => {
        html = html.replace('<p><br></p>', '');
        if (html.length > 3000) {
          this.$message.error({
            content: "机构简介内容不能超过3000字，请重新输入!",
            duration: 2
          });
          this.editor.txt.html(this.value);
        } else {
          this.$emit("change", html);
        }
      };
      if (this.isedit) {
        this.editor.customConfig.menus = [
          'head',  // 标题
          'bold',  // 粗体
          'fontSize',  // 字号
          'fontName',  // 字体
          'italic',  // 斜体
          'underline',  // 下划线
          'strikeThrough',  // 删除线
          'foreColor',  // 文字颜色
          'backColor',  // 背景颜色
        ];
      } else {
        this.editor.customConfig.menus = [];
      }
      this.editor.create();
      if (this.value !== "") {
        this.editor.txt.html(this.value);
      }
    }
  }
};
</script>

<style lang="less">
.ant-editor-wang {
  .editor-wrapper {
    text-align: left;
    max-width: 940px;
  }
}
.w-e-text-container {
  z-index: 1 !important;
  height: 200px !important;
}
.unEdit .w-e-text-container {
  background: #f3f3f3;
  cursor: no-drop;
}
</style>



// WEBPACK FOOTER //
// src/components/common/WangEditor.vue